import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Scharnier from "../../doors/scharnier";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleScharnierSinglePanel extends ConfigurationProps {}
const SingleScharnierSinglePanel: React.FC<SingleScharnierSinglePanel> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SingleScharnierSinglePanel) => {
  const position0 = new Vector3(-0.4625, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale} scale-y={0.98}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        rotateNewLayouts={true}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
    </group>
  );
};

export default SingleScharnierSinglePanel;
